<template>
  <div id="Translation">

    <Head />
    <Login @LoginOpen="openL" v-if="isLogin" />
    <div class="translation">
      <main>
        <p class="Toptitle">{{ title[id] }}</p>
        <div class="btn" v-if="id == 1 && lid == 0" @click="release()">发布信息</div>
        <div class="left">
          <!-- 已登录 -->
          <div class="top" v-if="$uName">
            <img :src="userinfo.Image || require('../assets/Declare/10.png')">
            <div class="up" @click="uploadImg">
              <img src="../assets/back/9.png" alt="">
              上传头像
            </div>
            <div>
              <div class="name">
                <img src="../assets/Declare/tx.png">
                <p>{{ $uName }}</p>
              </div>
              <p>{{ userinfo.CompanyName }}</p>
            </div>
          </div>
          <!-- 未登录 -->
          <div class="top" v-else>
            <div class="img">
              <img src="../assets/Conversion/avatar.png" />
            </div>
            <div>
              <p>当前用户未登录</p>
              <p class="blue" @click="openLogin">请点击登录</p>
            </div>
          </div>
          <div class="nav">
            <ul>
              <li :class="id == 0 ? 'active' : ''" @click="show(0)">
                <p><img
                    :src="id == 0 ? require('../assets/Conversion/navW.png') : require('../assets/Conversion/navB.png')" />成果导航
                </p>
              </li>
              <li @click="show(1)" :class="id == 1 ? 'active' : ''">
                <p><img
                    :src="id == 1 ? require('../assets/Conversion/informationW.png') : require('../assets/Conversion/informationB.png')" />市场信息
                </p>
                <img src="../assets/Conversion/DownArrowW.png" class="arrow" v-if="id == 1 && !showImg" />
                <img src="../assets/Conversion/DownArrowB.png" alt v-else-if="id != 1" class="arrow" />
                <img src="../assets/Conversion/UpArrowW.png" alt v-else-if="id == 1 && showImg" class="arrow" />
              </li>
              <div v-if="showImg">
                <p :class="lid == 0 ? 'active' : ''" @click="listB(0)">信息列表</p>
                <p :class="lid == 1 ? 'active' : ''" @click="listB(1)">我的发布信息</p>
              </div>
              <li :class="id == 2 ? 'active' : ''" @click="show(2)">
                <p><img
                    :src="id == 2 ? require('../assets/Conversion/resultW.png') : require('../assets/Conversion/resultB.png')" />成功案例
                </p>
              </li>
              <li :class="id == 3 ? 'active' : ''" @click="show(3)">
                <p><img
                    :src="id == 3 ? require('../assets/Conversion/safeW.png') : require('../assets/Conversion/safeB.png')" />保障支持
                </p>
              </li>
              <!-- <li :class="id==2?'active':''">
                <p><img :src="id==2?require('../assets/Conversion/resultW.png'):require('../assets/Conversion/resultB.png')"/>成功案例</p>
              </li> -->
              <!-- <li :class="id==3?'active':''">
                <p><img :src="id==3?require('../assets/Conversion/safeW.png'):require('../assets/Conversion/safeB.png')"/>保障支持</p>
              </li> -->
            </ul>
          </div>
          <el-upload ref="uploads" id="upload1" style="opacity:0" class="avatar-uploader" :http-request="upload"
            :auto-upload="false" action="upload1" :on-success="handleSuccess" :on-change="submitUpload"
            :show-file-list="false" :before-upload="beforeAvatarUpload">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="container c1" v-if="id == 0">
          <ResultNav />
        </div>
        <div class="container c2" v-else-if="id == 1 && showDetails">
          <div class="lists" v-if="lid == 0">
            <div class="top">
              <p>
                需方发布信息
                <span>更多</span>
              </p>
              <ul>
                <li v-for="(item, index) in list2X" :key="index" @click="details(0)">
                  <span>{{ index + 1 }}. {{ item.msg }}</span>
                  <span class="time">{{ item.time }}</span>
                </li>
              </ul>
            </div>
            <div class="bottom">
              <p>
                供方发布信息
                <span>更多</span>
              </p>
              <ul>
                <li v-for="(item, index) in list2G" :key="index" @click="details(1)">
                  <span>{{ index + 1 }}. {{ item.msg }}</span>
                  <span class="time">{{ item.time }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="mylist" v-if="lid == 1">
            <div>
              <p>
                我的发布信息
                <span>更多</span>
              </p>
              <ul>
                <li v-for="(item, index) in list2M" :key="index">
                  <span>{{ index + 1 }}. {{ item.msg }}</span>
                  <span class="time">{{ item.time }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="release" v-if="releaseShow && lid == 0">
            <div class="bg"></div>
            <div class="info">
              <div class="title">
                发布信息
                <span @click="release()">X</span>
              </div>
              <div class="form">
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="1.3rem"
                  class="demo-ruleForm">
                  <el-form-item label="信息标题:" prop="title" :required="true">
                    <el-input v-model="ruleForm.title" placeholder="请输入您发布的信息标题"></el-input>
                  </el-form-item>
                  <el-form-item label="信息类型:" prop="type" :required="true">
                    <el-select v-model="ruleForm.type" placeholder="请选择您发布的信息类型">
                      <el-option label="需方" value="xufnag"></el-option>
                      <el-option label="供方" value="gongfang"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="联系单位:" prop="unit" :required="true">
                    <el-input v-model="ruleForm.unit" placeholder="请输入您的联系单位"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人员:" prop="people" :required="true">
                    <el-input v-model="ruleForm.people" placeholder="请输入您的联系人员"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话:" prop="phone" :required="true">
                    <el-input v-model="ruleForm.phone" placeholder="请输入您的联系电话"></el-input>
                  </el-form-item>
                  <el-form-item label="发布内容:" prop="container" :required="true">
                    <el-input type="textarea" v-model="ruleForm.container" placeholder="请输入您的发布内容"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">发布</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <MarketDetails :showDetails="showDetails" v-else-if="id == 1 && !showDetails" @show="showD" :gf="gf">{{ this.type }}
        </MarketDetails>
        <div class="container c3" v-if="id == 2">
          <SuccessfulCase />
        </div>
        <div class="container c4" v-if="id == 3">
          <AssuranceSupport />
        </div>
      </main>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import Login from "../components/Login";
import MarketDetails from "../views/MarketDetails";
import SuccessfulCase from "./SuccessfulCase"
import AssuranceSupport from "./AssuranceSupport"
import ResultNav from "./ResultNav"
export default {
  name: "Translation",
  data() {
    var checkTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入信息标题"));
      }
    };
    var checkType = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入信息类型"));
      }
    };
    var checkUnit = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入联系单位"));
      }
    };
    var checkPeople = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入联系人员"));
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入联系电话"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          return callback(new Error("联系电话格式有误"));
        }
      }
    };
    var checkContainer = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入发布内容"));
      }
    };
    return {
      ruleForm: {
        title: "",
        type: "",
        unit: "",
        people: "",
        phone: "",
        container: ""
      },
      rules: {
        title: [{ validator: checkTitle, trigger: "blur" }],
        type: [{ validator: checkType, trigger: "blur" }],
        unit: [{ validator: checkUnit, trigger: "blur" }],
        people: [{ validator: checkPeople, trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
        container: [{ validator: checkContainer, trigger: "blur" }]
      },
      list1: [
        "现代企业“大财务”管理平台创新建立与实践",
        "人力资源会计在施工企业中的应用及研究",
        "精益成本管理在膏体充填开采中的研究与应用",
        "EVA诊断模型研究与实践",
        "防控区域施工项目运营风险的财务管理创新与实践",
        "基于托管运营为核心的轻资产管理实践",
        "建筑企业实施项目成本标准化管控的探索与实践",
        "煤炭企业控制工程施工成本有效途径的探索与实践",
        "煤炭施工企业项目成本精细化管理的探索与实践",
        "煤炭铁路运销企业资金链良性循环管理",
        "铁路运销企业内部市场化运行方案及结算研究",
        "细化施工企业财务预算管理的研究与应用",
        "以托管运营为核心的选煤厂轻资产管理",
        "构建企业依托政府资源的涉法涉诉信访工作体系",
        "“363”沟通机制的建立与实践",
        "煤矿安全诚信管理研究与实践",
        "创建国家安全标准化一级水泥的企业探索与实践",
        "建筑施工企业履行社会责任的探讨与实践",
        "基于内循环、零排放的水资源治理为核心的生态环保矿山实践",
        "构建水泥企业环保节能体系的探索与实践",
        "条带煤柱复采安全技术对策",
        "采煤塌陷区复垦管理创新与实践",
        "安全时空分析与轨迹变换管控技术提升与应用",
        "集团公司技术创新考核体系",
        "快速高效开展膏体充填项目的探索与研究",
        "实施技术创新打造绿色矿山",
        "水泥企业自动化生产管理系统的创新与实践",
        "危机文化建设的探索与实践",
        "国企党建思想政治工作内部市场化运作的探索与实践",
        "岱庄煤矿基于多元成本文化建设的探索与实践",
        "矿井建设流动项目部“家文化”的建设与系统推进",
        "推行“微型党课”教育提升党员素质",
        "淄矿集团党委加强作风建设密切联系职工的创新与实践",
        "全面风险管理在企业经济运行中的探索和应用",
        "煤矿工程造价控制审核的探索与研究",
        "外委工程成本管理的探索与实践",
        "构建惩治和预防腐败体系建设的研究与实践",
        "廉洁风险防控管理体系在煤炭企业的研究与实践",
        "管理创新成果全面风险管控体系的创建与实施",
        "多元策略应对建筑施工企业风险",
        "全面风险管理体系研究设计与实施",
        "全面风险管理在基本建设企业的应用",
        "水泥企业并购中的法律风险防控与实践",
        "水泥企业法律风险防控的探索与实践",
        "创新考核分配机制探索实施管理岗位“人单酬”管理",
        "内部人才市场在建筑施工企业中的应用与实践",
        "员工帮助计划在企业思想政治工作中的创新与应用",
        "煤炭施工企业“精用工”管控的实践与应用",
        "专业人员继续教育培训学分制考核体系的创建及应用",
        "“塔”式技能人才体系  力促轻型矿井建设",
        "基于五项机制的职工队伍建设的研究与实践",
        "倾力锻造“双百人才” 助力企业科学发展的探索与实践",
        "淄矿集团建立人才多序列职业发展机制的探索与实践",
        "淄矿集团专业技术岗位发展通道的设立与应用",
        "国有企业补充医疗保险体系的建立与实施",
        "煤炭铁路专运用线基于关键绩效指标（KPI）考核的绩效管理",
        "煤炭施工企业职工队伍素质提升的探索及实践",
        "水泥企业岗位绩效考核分配体系与内部市场化融合的创新实践",
        "四位一体绩效管理考核体系的构建",
        "以全员绩效量化考核推动新建矿井转型发展的研究与实践",
        "运用“精用工”管理机制打造精优团队",
        "职工技能提升上岗准入机制的创新与实践",
        "煤矿安全事故风险动态管控",
        "以“设备包机制”为导向的生产线管理",
        "积极探索煤场管理新方法为企业生产经营保驾护航",
        "煤矿安全教育培训教材的编制与应用",
        "企业内部市场化管理的创新与应用",
        "提案改善在精益管理工作中的突出作用",
        "中小发电企业利用热电联产之路开创经济发展新亮点",
        "材料复用精细化创新管理",
        "高效集约生产，辅助专业化管理研究与应用",
        "基于内部市场化班组对标管理体系构建与实施",
        "建筑施工企业优化现场管理的探索与实践",
        "煤矿辅助生产专业化的探索与实施",
        "煤矿专用铁路转型发展与升级管理",
        "煤质防控管理体系的探索与实践",
        "内涵深化创新提升后勤管理服务水平",
        "三比三看三对照煤矿企业中的实践与应用",
        "煤矿企业三四级市场的探索与实践",
        "推行废旧物料管理实现节本降耗增效",
        "项目标准化管理在煤炭施工企业的实施",
        "新型干法水泥企业测量体系运行实践",
        "“提煤质、降单耗、保煤价”研究与实施",
        "基于煤炭产品结构调整的营销模式创新",
        "煤炭企业营销模式创新在应对煤炭危机中的探索与实践",
        "“三三二二”物资招标体系的构建与实施",
        "新动能主导煤炭物流企业转型发展的探索与实践",
        "企业级煤矿安全监察远程信息化系统研究与应用",
        "新形势下通讯信息管理模式的优化改进与实践",
        "岱庄煤矿安全风险预控管理体系信息支撑平台创建",
        "基于信息网络平台的企业思想政治工作探索与实践",
        "“矿区铁路安全管理信息化研究与应用”项目总结",
        "煤炭企业计划统计信息管理流程再造的探索与实践",
        "以提高吨煤创效能力为目标的产品优化战略研究",
        "煤炭企业全面市场化改革的探索与实践",
        "管理创新成果混合所有制改制激发企业活力",
        "技术/销售绑定式的科技大营销管理模式",
        "外部对标管理体系在煤炭企业治亏创效中的研究与应用",
        "基于内部市场化创新型矿井建设的探索与实践",
        "经济形势逆变保持稳定健康发展的实践",
        "矿区铁路运营模式转型的探索与实践",
        "煤炭基本建设企业创新产业发展模式的探索与实践",
        "煤炭企业提高经济运行质量的探索与实践",
        "煤炭企业推行内部市场化管理模式的探索与实践",
        "煤炭施工企业专业化管理模式创新与应用",
        "市场下行形势下煤炭建设项目再评价研究与实施",
        "以增值增效为目标的产品结构调整战略研究",
        "资源型企业发展结构性生产力的探索与实践",
        "资源型企业基于审慎原则的多元化投资战略",
        "“3+1”模式提升服务职工群众能力",
        "“五全十制”内部市场化管理在经济逆势中的突出作用",
        "岗位练兵长效机制实施",
        "驻矿督导安全管理模式的应用",
        "水泥公司二级单位“事业部制”改革的探索与实践",
        "水泥公司推行“大后勤”管理模式的创新与实践",
        "推行完全市场化项目部运作模式的探索与实践",
        "许 厂 煤 矿“四自”班组模式在煤炭企业中的探索与应用",
        "大区队机构改革在生产组织中的探索与实践",
        "发挥“六个引领作用”保障企业转型跨越发展",
        "煤炭企业轮值班组长的探索与践",
        "煤炭企业强化企业管理运行机制的探索与实践",
        "以提高资源保障能力为核心的“3331”生产组织模式研究与实践",
        "安全质量标准化在本质安全矿井建设中的作用"
      ],
      list2X: [
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        }
      ],
      list2G: [
        {
          msg:
            "2020-03-29润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        }
      ],
      list2M: [
        {
          msg:
            "2020-03-29润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        },
        {
          msg:
            "2020-03-19润电能源科学技术有限公司调试工程现场人员技术服务招标公告",
          time: "2020-02-12"
        }
      ],
      title: ["成果导航", "市场信息", "成功案例", "保障支持"],
      showImg: false,
      isLogin: false,
      id: "",
      lid: "",
      releaseShow: false,
      showDetails: true,
      type: '',
      gf: '',
      userinfo: {}
    };
  },
  components: {
    Head,
    Foot,
    Login,
    MarketDetails,
    ResultNav,
    SuccessfulCase,
    AssuranceSupport
  },
  created() {
    this.id = this.$route.params.Tid;
    console.log(this.id);
    if (this.id == 1) {
      this.showImg = true
    }
    this.userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
  },
  mounted() {
    document.querySelector('#Head .nav_main li:nth-of-type(7) a').classList.add('active')
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openLogin() {
      this.isLogin = true;
    },
    openL(e) {
      console.log(2, e);

      this.isLogin = e;
    },
    show(i) {
      this.id = i;
      if (this.id != 1) {
        this.showImg = false
      } else {
        this.showImg = !this.showImg;
      }
    },
    listB(i) {
      this.lid = i;
      this.showDetails = true
    },
    release() {
      this.releaseShow = !this.releaseShow;
    },
    changeSelect(e) {
      e.target.className = "active";
    },
    details(index) {
      this.showDetails = false
      if (index == 0) {
        this.type = "需方"
        this.gf = 0
      } else {
        this.type = "供方"
        this.gf = 1
      }
    },
    showD(ev) {
      this.showDetails = ev
    },
    uploadImg() {
      document.querySelector(".avatar-uploader input").click()
    },
    submitUpload() {
      this.$refs.uploads.submit();
    },
    // 测试上传
    handleSuccess(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || "image/gif" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    upload(file) {
      let that = this;
      console.log(file)
      var formData = new FormData();
      formData.append("file", file.file);
      formData.append("upload_type", 'image');
      that.$axios
        .post("upload/index?token=" + sessionStorage.getItem("token"), formData, {
          headers: {
            "Content-type": "multipart/form-data"
          }
        }).then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            this.userinfo.Image = res.data.data;
            let url = "user/update"
            var token = sessionStorage.getItem("token")
            if (token.split('-')[0] == 'company') {
              url = "company/update"
            }
            that.$axios
              .post(url + "?token=" + sessionStorage.getItem("token"), that.$qs.stringify(this.userinfo)).then(res => {
                console.log(res);
                if (res.data.code == 10000) {
                  this.$message({
                    message: res.data.msg,
                    type: 'success'
                  })
                  let arr = JSON.stringify(this.userinfo)
                  sessionStorage.setItem('userinfo', arr)
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              })
          }
          else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      this.$refs.uploads.clearFiles()
    }
  }
};
</script>
<style lang="less">
.translation {
  .el-textarea__inner {
    min-height: 1.5rem !important;
  }
}
</style>
<style lang="less" scoped>
.translation {
  padding: 0 1.35rem;
  margin-top: 0.44rem;

  main {

    // 标题
    .Toptitle {
      font-size: 0.3rem;
      color: #161616;
      text-align: center;
      width: 84%;
      margin-left: 16%
    }

    .btn {
      width: 1.2rem;
      height: 0.43rem;
      line-height: 0.43rem;
      background: #3e71c7;
      border-radius: 0.04rem;
      font-size: 0.18rem;
      color: #fff;
      text-align: center;
      float: right;
      margin-bottom: 0.13rem;
      cursor: pointer;
    }

    // 左侧导航栏
    .left {
      width: 15%;
      font-size: 0.18rem;
      float: left;
      margin-top: 0.75rem;

      .top {
        .img {
          width: 1.73rem;
          height: 2.23rem;
          background: #EFEFEF;
          padding: 0.49rem .3rem .38rem .29rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        >div {
          font-size: 0.18rem;
          color: #2a2a2a;
          margin: 0.1rem 0 0.24rem;
          line-height: 1.5;

          .blue {
            color: #57a6f7;
            cursor: pointer;
          }
        }

        >img {
          width: 1.73rem;
          height: 2.23rem;
        }

        .up {
          width: 1.73rem;
          height: 0.35rem;
          line-height: 0.35rem;
          background: #2D65D2;
          cursor: pointer;
          margin: 0;
          position: relative;
          top: -0.05rem;
          text-align: center;
          color: #fff;

          img {
            width: 0.24rem;
            height: 0.21rem;
            position: absolute;
            left: 0.15rem;
            top: 0.05rem;
          }
        }

        .name {
          display: flex;
          font-size: .2rem;
          font-weight: bold;
          margin: 0.2rem 0;

          img {
            width: 0.25rem;
            height: 0.28rem;
            margin-right: 0.1rem;
          }
        }
      }

      .nav {
        li {
          width: 2.21rem;
          height: 0.55rem;
          line-height: .55rem;
          border: 1px solid #afafaf;
          border-radius: 0.04rem;
          margin-bottom: 0.25rem;
          font-size: 0.18rem;
          color: #363636;
          padding-left: 0.17rem;
          cursor: pointer;
          position: relative;

          p {
            display: flex;
            align-items: center;

            img {
              width: 0.28rem;
              margin-right: 0.13rem;
            }
          }

          img.arrow {
            width: 0.18rem;
            height: 0.13rem;
            position: absolute;
            top: 40%;
            right: 0.2rem;
          }
        }

        li.active {
          background: #57a6f7;
          color: #fff;
          border: 0;
        }

        div {
          margin-bottom: 0.31rem;
          padding-left: 0.15rem;
          font-size: 0.18rem;
          color: #222020;
          cursor: pointer;

          :first-child {
            margin-bottom: 0.24rem;
          }

          .active {
            color: #57a6f7;
          }
        }
      }
    }

    // 主要内容
    .container {
      width: 84%;
      float: right;
      position: relative;
    }

    // 成果导航
    .c1 {
      margin-top: 0.66rem;
    }

    // 市场信息
    .c2 {
      >div>div {
        border: 1px solid #d9d9d9;
        padding: 0.21rem 0.23rem 0rem 0.18rem;

        p {
          font-size: 0.2rem;
          color: #3985d9;
          border-left: 0.04rem solid #3985d9;
          padding-left: 0.08rem;
          margin-bottom: 0.19rem;
          display: flex;
          justify-content: space-between;

          span {
            font-size: 0.18rem;
            color: #353535;
            cursor: pointer;
          }
        }

        li {
          font-size: 0.16rem;
          border-top: 1px solid #e1e1e1;
          padding: 0.15rem 0;
          color: #353535;
          cursor: pointer;

          .time {
            float: right;
            color: #959595;
          }
        }
      }

      .bottom {
        margin-top: 0.23rem;

        p {
          color: #fa621f;
          border-color: #fa621f;
        }
      }

      .release {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

        .bg {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
        }

        .info {
          min-width: 6.25rem;
          max-height: 8.2rem;
          background: #fff;
          z-index: 1;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border: 0;
          padding: 0;

          .title {
            font-size: 0.2rem;
            color: #3d3d3d;
            padding: 0.18rem 0.2rem 0.15rem;
            border-bottom: 1px solid #d4d4d4;
            text-align: center;

            span {
              font-size: 0.23rem;
              color: #c3bdbd;
              float: right;
              cursor: pointer;
            }
          }

          .form {
            padding: 0 0.35rem;
            position: relative;
            margin-top: 0.3rem;

            .el-select {
              width: 100%;
            }

            .el-button {
              width: 100%;
              height: 0.5rem;
              font-weight: 400;
              font-size: 0.24rem;
            }
          }
        }
      }

      .mylist {
        margin-top: 0.6rem;
      }
    }

    // #MarketDetails /deep/ .type{

    // }
  }

  main:after {
    content: "";
    display: block;
    clear: both;
  }
}</style>